import React, {
  useEffect,
  useState,
  Suspense,
  useContext,
  useCallback,
} from "react";
import { Link } from "react-router-dom";
import { SendRaiseaFlag, ShowRaiseaFlag } from "./Services/RaiseaFlagService";
import { TostMsg } from "../../../../App";
import moment from "moment";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import { GetFAQList } from "../../../../Services/Global-Services/GlobalServices";
import { Paginator } from "primereact/paginator";
const ComponentLoader = React.lazy(() =>
  import("../../../../Shared/Sidebar/ComponentLoader")
);
const defaultImage = "/images/placeholder_profile.png";

const RaiseaFlag = () => {
  const [raiseFlageDataList, setRaiseFlagDataList] = useState([]);
  const [faqLists, setFAQLists] = useState([]);
  const [loader, setLoading] = useState(false);
  const toster = useContext(TostMsg);
  const [text, setText] = useState();
  const [isChecked, setIsChecked] = useState(false);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "");
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [raiseFlagDes, setRaiseFlagDes] = useState("");
  const [filterStartDate, setFilterStartDate] = useState("02/01/2016");
  const [filterEndDate, setFilterEndDate] = useState("02/01/2029");
  const [activeFAQIndex, setActiveFAQIndex] = useState(null);
  const [isInvalidText, setIsInvalid] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});

  useEffect(() => {
    GetRaiseaFlag(currentPage, rowsPerPage);
    GetMasterSystemAlertList();
    GetFAQ();
  }, []);

  useEffect(() => {
    if (raiseFlageDataList.length > 0) {
      GetRaiseaFlag(currentPage, rowsPerPage);
    }
  }, [raiseFlageDataList]);

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  async function GetRaiseaFlag(pageNumber, pageSize) {
    setLoading(true);
    const body = {
      filterStartDate: filterStartDate,
      filterEndDate: filterEndDate,
      PageNumber: pageNumber + 1,
      PageSize: pageSize,
    };
    try {
      let response = await ShowRaiseaFlag(body);
      setRaiseFlagDataList(response?.Data);
      setTotalRecords(response?.Data?.TotalRaisedFlagcount);
      setLoading(false);
    } catch (error) {
      toster.current.error(ERROR_LIST?.RaiseaFlag);
      setLoading(false);
    }
  }

  async function SaveRaiseaFlag() {
    if (text) {
      setIsInvalid(false);
      setLoading(true);
      const body = {
        RaisedFlag: text,
        IsAnonymous: isChecked,
      };
      try {
        const response = await SendRaiseaFlag(body);
        if (response) {
          GetRaiseaFlag(currentPage, rowsPerPage);
          setText("");
          setLoading(false);
          GetMasterSystemAlertList("Flag__submitted", 0);
        }
      } catch (err) {
        setLoading(false);
      }
      setIsChecked(false);
    } else {
      setIsInvalid(true);
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == "Raise_flag_Description") {
        setRaiseFlagDes(msg?.Desc);
      }
    });
  }, []);

  async function GetFAQ() {
    setLoading(true);
    const body = {
      FAQTypeId: 101,
    };
    try {
      const response = await GetFAQList(body);
      setFAQLists(response?.Data);
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    } finally {
      setLoading(false);
    }
  }

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const onPageChange = (e) => {
    setCurrentPage(e.page);
    setRowsPerPage(e.rows);
    GetRaiseaFlag(e.page, e.rows);
  };

  const toggleRow = (index) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row g-3">
          <div>
            <div className="col-md-12">
              <div className="card">
                <img
                  src="images/org-img/leave/popup-backimg.png"
                  style={{
                    position: "absolute",
                    right: "0",
                    width: "100%",
                    opacity: "0.4",
                  }}
                />
                <div className="card-body" style={{ padding: "1rem" }}>
                  <div className="block-header">
                    <div className="rightfeed-form center1">
                      <h2>Raise a Flag</h2>
                      <p>{raiseFlagDes}</p>
                      <div className="give-rate">
                        <span className="block-heading">Concern</span>
                      </div>
                      <div className="form-group d-flex position-relative raise-textarea">
                        <textarea
                          className="form-control"
                          rows="4"
                          maxLength={250}
                          placeholder="Please type here..."
                          onChange={(event) => {
                            setText(event?.target?.value);
                            setIsInvalid(false);
                          }}
                          value={text}
                        ></textarea>
                        <div
                          style={{
                            textAlign: "right",
                            fontSize: "12px",
                            position: "absolute",
                            right: "27px",
                            bottom: "1px",
                            color: text?.length >= 250 ? "red" : "#555",
                          }}
                        >
                          {text?.length || 0}/250
                        </div>
                      </div>
                      <div className="invalid-feedback">
                        {isInvalidText ? "Concern is required." : null}
                      </div>
                      <div className="form-group d-flex anonymous">
                        <input
                          type="checkbox"
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                        />
                        <label>
                          {isChecked ? "Is Anonymous" : "Is Anonymous"}
                        </label>
                      </div>
                      <button
                        className="sendfeed"
                        type="button"
                        onClick={() => SaveRaiseaFlag()}
                        // disabled={text.length <= 3}
                      >
                        Raise Flag
                      </button>
                    </div>
                  </div>
                  <div className="latest-feedreview">
                    <div
                      className="me-auto"
                      style={{
                        padding: "1rem 0rem 0rem 0rem",
                        textAlign: "center",
                      }}
                    >
                      <h2 className="font-w600 mb-0">History</h2>
                    </div>
                    <div className="col-xl-12 mt-4  historylist">
                      <table className="table table-bordered table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th scope="col" style={{ width: "50px" }}>
                              Sr. No.
                            </th>
                            <th scope="col">Date</th>
                            <th scope="col" style={{ width: "298px" }}>
                              Concern
                            </th>
                            <th scope="col">Reponse</th>
                            <th scope="col">Response By</th>
                            <th scope="col">Response On</th>
                          </tr>
                        </thead>
                        <tbody>
                          {raiseFlageDataList?.orgEmpRaiseFlagListResponse?.map(
                            (el, index) => (
                              <tr key={index}>
                                <td scope="row">{index + 1}</td>
                                <td>
                                  {moment(el?.CreatedDate).format(
                                    "MMM DD YYYY"
                                  )}
                                </td>
                                <td className="concern-w">
                                  {/* {el.RaisedFlag ? el.RaisedFlag : "N/A"} */}

                                  {el.RaisedFlag?.length > 30 &&
                                  !expandedRows[index] ? (
                                    <>
                                      {el.RaisedFlag.slice(0, 30)}...
                                      <span
                                        style={{
                                          color: "red",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => toggleRow(index)}
                                      >
                                        read more
                                      </span>
                                    </>
                                  ) : (
                                    el.RaisedFlag || "N/A"
                                  )}
                                </td>
                                <td>{el.Response ? el.Response : "N/A"}</td>
                                <td>
                                  <div className="user-block d-flex p-0 align-items-center">
                                    {el.Response &&
                                      el.ModifiedByName &&
                                      el.ModifiedByProfileImage && (
                                        <img
                                          src={el.ModifiedByProfileImage}
                                          onError={handleImageError}
                                          width="20"
                                          className="me-1"
                                          style={{
                                            opacity: 1,
                                            borderRadius: "13px",
                                          }}
                                          data-demo-src="/images/main-body/1.jpg"
                                        />
                                      )}
                                    {el.Response && el.ModifiedByName
                                      ? el.ModifiedByName
                                      : "N/A"}
                                  </div>
                                </td>
                                <td>
                                  {moment(el?.ModifiedDate).format(
                                    "MMM DD YYYY"
                                  )}
                                </td>
                              </tr>
                            )
                          )}

                          {raiseFlageDataList?.orgEmpRaiseFlagListResponse
                            ?.length === 0 && (
                            <tr>
                              <td colSpan="6" className="text-center">
                                No data found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <div className="paginations">
                        <Paginator
                          rows={rowsPerPage}
                          first={currentPage * rowsPerPage}
                          totalRecords={totalRecords}
                          rowsPerPageOptions={[10, 20, 30, 40]}
                          onPageChange={onPageChange}
                        />
                      </div>
                    </div>
                    <div
                      className="me-auto mt-4"
                      style={{
                        padding: "1rem 0rem 0rem 0rem",
                        textAlign: "center",
                      }}
                    >
                      <h2 className="font-w600 mb-0">
                        Frequently Asked Questions
                      </h2>
                    </div>
                    <div className="col-xl-12 faqlist">
                      <div className="accordion">
                        <div className="row">
                          {faqLists?.map((el, index) => (
                            <div className="col-md-6" key={index}>
                              <div className="accordion-item">
                                <h2
                                  className="accordion-header"
                                  id={`heading-${index}`}
                                >
                                  <button
                                    className={`accordion-button ${
                                      activeFAQIndex === index
                                        ? ""
                                        : "collapsed"
                                    }`}
                                    type="button"
                                    onClick={() =>
                                      setActiveFAQIndex((prev) =>
                                        prev === index ? null : index
                                      )
                                    }
                                    aria-expanded={activeFAQIndex === index}
                                    aria-controls={`collapse-${index}`}
                                  >
                                    {el.Question}
                                  </button>
                                </h2>
                                <div
                                  id={`collapse-${index}`}
                                  className={`accordion-collapse collapse ${
                                    activeFAQIndex === index ? "show" : ""
                                  }`}
                                  aria-labelledby={`heading-${index}`}
                                >
                                  <div className="accordion-body">
                                    <p>{el.Answer}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="contact-manager">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title m-auto">
                Contact Your Reporting Manager htmlFor Any Leave Clarifications
              </h5>
            </div>
            <div className="modal-body text-center">
              <form>
                <div className="form-group text-left">
                  <label>Repoting Manager</label>
                  <select className="default-select form-control wide mb-3">
                    <option selected disabled>
                      Select reporting manager
                    </option>
                    <option>Arun Mishra</option>
                    <option>Pragya Tiwari</option>
                    <option>Alisha Goyal</option>
                  </select>
                </div>
                <div className="form-group text-left">
                  <label className="mt-3">Reason</label>
                  <textarea
                    rows="4"
                    cols="1"
                    className="form-control"
                  ></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
              >
                Decline
              </button>
              <button type="button" className="btn btn-primary">
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
      {loader ? (
        <Suspense >
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default RaiseaFlag;
